export const decodeJWT = (token: string) => {
	if (!token) return '';
    // Split the token into its three parts
    const parts = token.split('.');

    if (parts.length !== 3) {
        throw new Error('Invalid token');
    }

    // Decode the payload (the second part of the token)
    const payload = parts[1];

    // Base64 decode the payload (URL-safe base64 decoding)
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));

    // Return the decoded JSON (usually the claims object)
    return JSON.parse(decodedPayload);
}
